import React, { createContext, useState, useContext, useEffect, ReactElement, ReactNode } from 'react';
import { IShareablePage, IGetShareablePageQuery } from '../interfaces';

interface IShareablePageContext {
  shareablePage?: IShareablePage,
  error?: string,
  loading: boolean
}

const ShareablePageContext = createContext<IShareablePageContext>({
  shareablePage: void 0,
  error: void 0,
  loading: true
});

export default ShareablePageContext;

interface ShareablePageProviderProps {
  children: ReactNode;
  getShareablePage: IGetShareablePageQuery
}

export function ShareablePageProvider({
  children,
  getShareablePage
}: ShareablePageProviderProps): ReactElement {
  const [shareablePage, setShareablePage] = useState<IShareablePage | undefined>(void 0);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined>(void 0);

  useEffect(() => {
    (async () => {
      const {
        data: { getShareablePage: pageData } = {},
        error: err
      } = await getShareablePage();

      if (err) {
        setError(err);
      }

      if (pageData) {
        setShareablePage(pageData);
      }

      setLoading(false);
    })();
  });

  return (
    <ShareablePageContext.Provider
      value={{
        shareablePage,
        loading,
        error
      }}
    >
      {children}
    </ShareablePageContext.Provider>
  );
}

export function useShareablePageContext(): IShareablePageContext {
  return useContext(ShareablePageContext);
}
